import { CURRENT_NETWORK } from '../config/networks';

// Switch the wallet to the required network.
// Falls back to adding the chain if not present.
// Does NOT reload the page.
export async function ensureCorrectNetwork(provider) {
  if (!provider) throw new Error('No wallet provider');

  const targetHex = CURRENT_NETWORK.chainIdHex;

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: targetHex }],
    });
    return true;
  } catch (err) {
    // Chain not added yet
    if (err && (err.code === 4902 || err.code === -32603 || (err.data && err.data.originalError && err.data.originalError.code === 4902))) {
      try {
        await provider.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: targetHex,
              chainName: CURRENT_NETWORK.name,
              nativeCurrency: CURRENT_NETWORK.nativeCurrency,
              rpcUrls: CURRENT_NETWORK.rpcUrls,
              blockExplorerUrls: [CURRENT_NETWORK.blockExplorer],
            },
          ],
        });
        return true;
      } catch (addErr) {
        throw new Error('Please add the network in your wallet.');
      }
    }
    if (err && err.code === 4001) {
      throw new Error('Network switch rejected.');
    }
    throw new Error(err?.message || 'Could not switch network.');
  }
}

export function isCorrectChain(chainId) {
  return Number(chainId) === CURRENT_NETWORK.chainId;
}
